/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {CurrencyBaseMapper} from '../../currency/currency-base.mapper';
import {BundleSpecDetailContract} from '../../../api/contracts/bundle/bundle-spec-detail.contract';
import {BundleSpecDetailModel} from './bundle-spec-detail.model';
import {ReferenceDataMapper} from '../../reference-data/reference-data.mapper';


export class BundleSpecDetailMapper {

    static fromBundleSpecBaseContract(input: BundleSpecDetailContract): BundleSpecDetailModel {
        let model: BundleSpecDetailModel;

        if (input != null) {
            model = {
                code: input.code,
                maxPositions: input.maxPositions,
                maxValue: input.maxValue,
                currency: CurrencyBaseMapper.fromCurrencyBaseContract(input.currency),
                criteriaSpecs: ReferenceDataMapper.fromReferenceDataContractArray(input.criteriaSpecs),
                valuesSpecs: ReferenceDataMapper.fromReferenceDataContractArray(input.valuesSpecs)
            };
        }
        return model;
    }
}
